import { Injectable } from "@angular/core";
import { StateService } from "@core-services/state.service";
import { StakingBannerState } from "@modules/staking/domain/entities/staking-banner-state.model";
import { Observable } from "rxjs";

export const initialState: StakingBannerState = {
	hasError: false,
	init: false,
	notStakingCurrently: true,
	highestYield: 0,
	stakedCoins: 0,
	totalLifetimeRewards: 0,
	buttonKey: "",
	stakedItemsId: [],
	assetConfig: null,
	isHideActive: false
};

@Injectable({
	providedIn: "root"
})
export class StakingBannerStateService extends StateService<StakingBannerState> {
	constructor() {
		super(initialState);
	}

	public getHighestYield(): Observable<number> {
		return this.select((state: StakingBannerState) => state.highestYield);
	}

	public getCurrentlyStaking(): Observable<boolean> {
		return this.select((state: StakingBannerState) => state.notStakingCurrently);
	}

	public updateState(state: Partial<StakingBannerState>): void {
		this.setState({ ...this.state, ...state });
	}

	public getBannerState$(): Observable<StakingBannerState> {
		return this.select((state) => state);
	}
}
